module.exports = __webpack_public_path__ + "img/product-properties.9a8c9b3c.svg";